import React, {Component} from "react";
import {BrowserRouter, Redirect, Switch} from 'react-router-dom';
import "./App.css";
import LandingPage from "./components/layout/landing_page/LandingPage";
import LogIn from "./components/layout/auth/login/LogIn";
import Register from "./components/layout/auth/register/Register";
import ConfirmAccount from "./components/layout/auth/register/ConfirmAccount";
import SurveysPage from "./components/layout/surveys/SurveysPage";
import SurveyPage from "./components/layout/survey/SurveyPage";
import PublicRoute from "./components/routes/PublicRoute";
import PrivateRoute from "./components/routes/PrivateRoute";
import SocialAuthPage from "./components/layout/auth/social_channels/SocialAuthPage";
import ActivateAccount from "./components/layout/auth/register/ActivateAccount";
import PasswordReset from "./components/layout/auth/password_reset/PasswordReset";
import ContactPage from "./components/layout/contact/ContactPage";
import HelpPage from "./components/layout/help/HelpPage";
import AccountPage from "./components/layout/account_page/AccountPage";
import SurveyTemplatesPage from "./components/layout/surveys/survey_templates/SurveyTemplatesPage";
import PricingPage from "./components/layout/pricing/PricingPage";
import PageNotFound from "./components/meta/PageNotFound";
import ThankYouPage from "./components/layout/thank_you/ThankYouPage";

class App extends Component {
    render() {
        return (
            <BrowserRouter>
                <Switch>
                    <PublicRoute restricted={true} exact path="/" component={LandingPage}/>
                    <PublicRoute restricted={false} path="/login" component={LogIn}/>
                    <PublicRoute restricted={false} path="/register" component={Register}/>
                    <PublicRoute restricted={false} path="/confirm-account" component={ConfirmAccount}/>
                    <PublicRoute restricted={false} path="/social-auth" component={SocialAuthPage}/>
                    <PublicRoute restricted={false} path="/activate-account" component={ActivateAccount}/>
                    <PublicRoute restricted={false} path="/password-reset" component={PasswordReset}/>
                    <PublicRoute restricted={false} path="/contact" component={ContactPage}/>
                    <PublicRoute restricted={false} path="/help-center" component={HelpPage}/>
                    <PublicRoute restricted={false} path="/pricing" component={PricingPage}/>
                    <PublicRoute path="/404" component={PageNotFound}/>
                    <PublicRoute path="/survey-templates" component={SurveyTemplatesPage}/>
                    <PublicRoute restricted={false} path="/thank-you" component={ThankYouPage}/>
                    <PrivateRoute exact path="/surveys" component={SurveysPage}/>
                    <PrivateRoute path="/survey" component={SurveyPage}/>
                    <PrivateRoute path="/survey-templates" component={SurveyTemplatesPage}/>
                    <PrivateRoute exact path="/my-account" component={AccountPage}/>
                    <Redirect to="/404" />
                </Switch>
            </BrowserRouter>
        );
    }
}

export default App;
